import { onCleanup } from './cleanup.js'

function accordion (autoScroll = false) {
  const headings = document.querySelectorAll('.accordion-heading')
  const triggers = []
  const accordionContents = document.querySelectorAll('.accordion-copy')
  const copyOpenClass = 'accordion-copy--open'
  const multiselect = true

  headings.forEach((h, i) => {
    const btn = h.querySelector('button')
    triggers.push(btn)

    // Instead of using nextElementSibling, use the data-content-id attribute
    const contentId = btn.getAttribute('data-content-id')
    const target = contentId ? document.getElementById(contentId) : h.nextElementSibling

    btn.onclick = () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true'
      if (expanded) {
        closeItem(target, btn)
      } else {
        openItem(target, btn, h)
      }
    }
  })

  // Inicializar maxHeight para items que ya están expandidos
  function initExpandedItems() {
    headings.forEach((h) => {
      const btn = h.querySelector('button')
      const contentId = btn.getAttribute('data-content-id')
      const target = contentId ? document.getElementById(contentId) : h.nextElementSibling
      
      if (btn.getAttribute('aria-expanded') === 'true' && target.classList.contains(copyOpenClass)) {
        const copyH = target.scrollHeight + 40
        target.style.maxHeight = copyH + 'px'
        target.style.padding = 'var(--content-padding)'
        // console.log('Accordion initialized with height:', copyH + 'px', target)
      }
    })
  }

  // Ejecutar después de que las imágenes se carguen
  if (document.readyState === 'complete') {
    initExpandedItems()
  } else {
    // once: el listener vive en window y sobrevive a la transición; sin esto
    // se acumulaba uno por navegación, cada uno reteniendo headings detached.
    window.addEventListener('load', initExpandedItems, { once: true })
    onCleanup(() => window.removeEventListener('load', initExpandedItems))
  }

  // También ejecutar con un pequeño delay como fallback
  const initTimer = setTimeout(initExpandedItems, 200)
  onCleanup(() => clearTimeout(initTimer))

  function closeAllExpandedItems () {
    const expandedTriggers = triggers.filter(
      (t) => t.getAttribute('aria-expanded') === 'true'
    )
    const expandedCopy = Array.from(accordionContents).filter((c) =>
      c.classList.value.includes(copyOpenClass)
    )
    expandedTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', false)
    })
    expandedCopy.forEach((copy) => {
      copy.classList.remove(copyOpenClass)
      copy.style.maxHeight = 0
      copy.style.padding = 'var(--content-padding)'
    })
  }

  function closeItem (target, btn) {
    if (multiselect) {
      btn.setAttribute('aria-expanded', false)
      target.classList.remove(copyOpenClass)
      target.style.maxHeight = '0px'
      target.style.padding = '0'
    } else {
      closeAllExpandedItems()
    }
  }

  function openItem (target, btn, heading) {
    if (!multiselect) {
      closeAllExpandedItems()
    }

    // Primero establecer maxHeight a 0 para preparar la transición
    target.style.maxHeight = '0px'
    
    // Forzar un reflow para que el navegador registre el cambio
    target.offsetHeight
    
    // Calcular la altura real del contenido
    const copyH = target.scrollHeight + 40

    btn.setAttribute('aria-expanded', true)
    target.classList.add(copyOpenClass)
    
    // Usar requestAnimationFrame para asegurar que la transición se ejecute
    requestAnimationFrame(() => {
      target.style.maxHeight = copyH + 'px'
      target.style.padding = 'var(--content-padding)'
    })

    // Scroll suave hacia el trigger después de que se abra el accordion (solo si autoScroll está activado)
    if (autoScroll) {
      setTimeout(() => {
        const offset = 150 // Offset desde el top de la ventana
        const triggerRect = btn.getBoundingClientRect()
        const triggerPosition = triggerRect.top + window.scrollY - offset
        
        // console.log('Accordion scroll triggered')
        // console.log('Trigger position:', triggerPosition)
        // // console.log('Current scroll:', window.scrollY)
        // // console.log('Lenis instance:', window.lenisInstance)
        
        // Usar Lenis si está disponible, sino usar scroll nativo
        if (window.lenisInstance) {
          // // console.log('Using Lenis scroll to:', triggerPosition)
          window.lenisInstance.scrollTo(triggerPosition, {
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            lock: true
          })
        } else {
          // // console.log('Using native scroll')
          window.scrollTo({
            top: triggerPosition,
            behavior: 'smooth'
          })
        }
      }, 300) // Esperar 300ms para que la animación de apertura esté más avanzada
    }
  }

  // Habilitamos esto si queremos el primer item abierto
  // setTimeout(() => triggers[0].click(), 750);
}

export default accordion

